import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ProjectCreatorApiService } from '../services/project-creator-api.service';
import { BaseProjectCreator } from './base-project-creator.controller';

export class ProjectCreatorFifthStepController extends BaseProjectCreator {
  get defaultFormValues() {
    return {};
  }

  constructor(private api: ProjectCreatorApiService) {
    super();
  }

  submit(token: string, step?: number): any {
    return of(null).pipe(switchMap(() => this.api.getFullProjectData(token)));
  }

  submitInternal(id: number, step?: number): any {
    return of(null).pipe(switchMap(() => this.api.getProjectById(id)));
  }
}
